module.exports = __webpack_public_path__ + "img/sean-pollock-PhYq704ffdA-unsplash.b8effdf4.jpg";